import { i18n as logoI18n } from 'src/components/logo/Logo.i18n';

const prefix = 'side-bar';

export const i18n = {
    dashboardLabel: {
        id: `${prefix}.dashboardLabel`,
        defaultMessage: 'Dashboard',
    },
    instancesLabel: {
        id: `${prefix}.instancesLabel`,
        defaultMessage: 'Instances',
    },
    usersLabel: {
        id: `${prefix}.usersLabel`,
        defaultMessage: 'Users',
    },
    supportPackagesLabel: {
        id: `${prefix}.supportPackagesLabel`,
        defaultMessage: 'Support Packages',
    },
    logoAlt: logoI18n.logoAlt,
} as const;
